import React from "react";
import DependentsCard from "./DependentsCard";
import { Ptag } from "components/core";
import { colors } from "theme";
import { Error } from "components/PlanSetup/styles";

const MEMBER_LIST = [
  "Employee",
  "Spouse",
  "Children",
  "Parents",
  "In-laws",
  "Sibling",
];

const DependentsCardList = ({
  handleClick,
  selectedDependents,
  submitCount,
  showHeading = true,
  isEmployeeDefaultPlan = false,
  isParentsDefaultPlan = false,
}) => {
  return (
    <section>
      {showHeading && (
        <Ptag
          color={colors.primaryColor}
          fontSize="18px"
          marginTop="40px"
          marginBottom="20px"
        >
          Dependents Covered
        </Ptag>
      )}
      <section
        style={{
          display: "flex",
          flexFlow: "wrap",
          gap: "1.4rem",
        }}
      >
        {MEMBER_LIST.map((name) => (
          <DependentsCard
            handleClick={() => handleClick(name)}
            selected={selectedDependents.includes(name)}
            disabled={(isEmployeeDefaultPlan && name === "Employee") || (isParentsDefaultPlan && name === "Parents")}
          >
          <Ptag>
            {name}
          </Ptag>
          </DependentsCard>
        ))}
      </section>
      {submitCount > 0 && !selectedDependents?.length && (
        <Error
          style={{
            position: "relative",
            bottom: "-1rem",
            fontSize: "12px",
          }}
        >
          *Required
        </Error>
      )}
    </section>
  );
};

export default DependentsCardList;
